export const blockIconsMapsDirectionsRun = (
	<span className='material-symbols-outlined'>directions_run</span>
);
